export default "__VITE_PUBLIC_ASSET__b111e717__"